import { useApolloClient } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { useQuasar } from 'quasar'
import { useSearchConfiguration } from 'src/helpers/searchConfiguration'
import EnergyTypeSelectionDialog from 'components/selection/EnergyTypeSelectionDialog.vue'

export const useEnergyTypeResolution = () => {
  const { client: apolloClient } = useApolloClient()
  const { getAvailableConfig } = useSearchConfiguration()
  const { dialog } = useQuasar()

  const getEnergyType = (category, contractEnergyType) => {
    switch (category) {
      case 'HEAT_PUMP':
      case 'NIGHT_STORAGE_HEATER':
        return 'electric_heating'
      default:
        return (category ?? contractEnergyType)?.toLowerCase()
    }
  }

  const getDistrictSearchEnergyType = (energyType) => {
    return energyType === 'electric_heating' ? 'electricity' : energyType
  }

  const promptSelection = (energyTypes, currentContractName) => {
    return new Promise(resolve => {
      dialog({
        component: EnergyTypeSelectionDialog,
        componentProps: {
          currentContractName,
          energyTypes
        }
      }).onOk(data => {
        resolve(data)
      }).onCancel(() => {
        resolve(null)
      }).onDismiss(() => {
        resolve(null)
      })
    })
  }

  const resolveCategory = ({ termProductId, contractEnergyType }) => {
    return apolloClient.query({
      query: gql`
      query ($termProductId: String!) {
        categoryByTermProductId (termProductId: $termProductId) {
          productId
          category
        }
      }`,
      variables: { termProductId }
    }).then(({ data }) => {
      const categoryInfo = data?.categoryByTermProductId ?? null
      const category = categoryInfo?.category ?? null
      const energyType = getEnergyType(category, contractEnergyType)

      const availableEnergyTypes = Object.keys(getAvailableConfig())
      const manualSelectionRequired = !category && contractEnergyType === 'electricity' && availableEnergyTypes.includes('electric_heating')

      return {
        category,
        categoryInfo,
        energyType,
        manualSelectionRequired
      }
    })
  }

  return {
    resolveCategory,
    promptSelection,
    getDistrictSearchEnergyType
  }
}
